<template>
  <div class="page-panel">
    <template v-if="$route.name=='article'">
      <div class="page-panel__header">
        <div class="page-panel-header__title">图文管理</div>
      </div>
      <div class="page-panel__body">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="企业动态" name="企业动态">
            <enterprise-list v-if="activeName=='企业动态'"></enterprise-list>
          </el-tab-pane>
          <el-tab-pane label="公司简介" name="公司简介">
            <briefIntroduction-list v-if="activeName=='公司简介'"></briefIntroduction-list>
          </el-tab-pane>
          <el-tab-pane label="人才招聘" name="人才招聘" v-if="$store.getters[gettersType.GET_LNG]!=='en-US'">
            <recruit-list v-if="activeName=='人才招聘'"></recruit-list>
          </el-tab-pane>
          <el-tab-pane label="领导团队" name="领导团队">
            <leaderList v-if="activeName=='领导团队'"></leaderList>
          </el-tab-pane>
          <el-tab-pane label="招标管理" name="招标管理">
            <tenderList v-if="activeName=='招标管理'"></tenderList>
          </el-tab-pane>
          <el-tab-pane label="视频中心" name="视频中心">
            <videoList v-if="activeName=='视频中心'"></videoList>
          </el-tab-pane>
        </el-tabs>
      </div>
    </template>
    <template v-if="$route.name!='article'">
      <router-view></router-view>
    </template>
  </div>
</template>
<script>
import * as gettersType from '@/store/getters/type';
import enterpriseList from './enterprise/list';
import briefIntroductionList from './briefIntroduction/list';
import recruitList from './recruit/list';
import leaderList from './leader/list';
import videoList from './video/list';
import tenderList from './tendering/list';
export default {
  data() {
    return { gettersType, activeName: '企业动态' };
  },
  components: {
    enterpriseList,
    briefIntroductionList,
    recruitList,
    leaderList,
    videoList,
    tenderList
  },
  methods: {
    handleClick() {}
  },
  created() {
    if (this.$route.params.activeTab) {
      this.activeName = this.$route.params.activeTab;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/adminCenter/page/article/index.vue